import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Agenda/filtrarAgenda`, method: 'POST', body: values, token: token})
}
